<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table 
            :headers="headers"
            :items="aprovalList"
            :search="search"
            sort-by="calories"
            class="elevation-1"
            >
            <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>Signatures</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>                    
                    <v-spacer></v-spacer>              
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    <!--<v-btn @click="listPartnoAlt()" color="primary" dark class="mb-2">Seach</v-btn> -->
                    <v-spacer></v-spacer>              
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>       
               <template>
                    <v-row justify="center">
                        <v-dialog v-model="dialog" persistent max-width="900px">
                       
                        <v-card>
                            <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                           
                            <v-card-text>                            
                            <v-container>                              
                                <v-flex xs12 sm12 md12 lg12 xl12>
                                    <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">  </div>
                                </v-flex>   
                                <v-row>
                                
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field maxlength="30" v-model="area" label="Area" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field maxlength="50" v-model="description" label="Description" required></v-text-field>
                                    </v-col>                                                                   
                                                                                                
                                </v-row>                            
                            </v-container>
                            <small>*indicates required field</small>
                            </v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>                            
                                <v-btn
                                    :disabled="dialogLoading"
                                    :loading="dialogLoading"
                                    color="blue darken-1" text @click="save"
                                    >
                                    Save
                                </v-btn>
                            
                           
                           <v-dialog
                                v-model="dialogLoading"
                                hide-overlay
                                persistent
                                width="300"
                                >
                                <v-card
                                    color="primary"
                                    dark
                                >
                                    <v-card-text>
                                    Saving, please be patient.
                                    <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                    ></v-progress-linear>
                                    </v-card-text>
                                </v-card>
                                </v-dialog>            

                            </v-card-actions>
                        </v-card>
                        </v-dialog>
                    </v-row>
                
                    <v-row>
                        <v-dialog v-model="adModal" persistent max-width="290px">
                        <v-card>
                            <v-card-title class="headline" v-if="adAccion == 1">Active Item?</v-card-title>
                            <v-card-title class="headline" v-if="adAccion == 2">Desactive Item?</v-card-title>
                            <v-card-text>
                                Are you sure to
                                <span v-if="adAccion==1">Activate </span>
                                <span v-if="adAccion==2">Deactivate </span>
                                this area {{adName}} ?
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text="text" @click="activateDesactivateClose">
                                    Cancel
                                </v-btn>
                                <v-btn v-if="adAccion==1" color="orange darken-4" text="text" @click="activate">
                                    Activate
                                </v-btn>
                                <v-btn v-if="adAccion==2" color="orange darken-4" text="text" @click="deactivate">
                                    Deactivate
                                </v-btn>
                                
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    </v-row>

                   <v-row>
                         <v-dialog v-model="verStatus" persistent max-width="800px"   >
                            <v-card>
                             <v-toolbar
                                color="indigo"
                                dark
                                >                               

                                <v-toolbar-title>ID: {{id_sign}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon @click="hideStatus">close</v-icon>
                                </v-btn>
                                </v-toolbar>
                         
                                <v-card-title> 
                                    <span class="headline">
                                       Sign this document 
                                    </span> 
                                    
                                </v-card-title>                            
                              
                                <v-card-text>

                                     <v-container  grid-list-sm class="pa-4 white" >              
                                        <v-layout row wrap>                  
                                        
                                           <v-flex xs12 sm4 md4 lg4 xl4>
                                                <v-select v-model="frmStatus" 
                                                    :items="statusSignItems" 
                                                    label="Status"> 
                                                </v-select>
                                            </v-flex>	
                                            <v-flex xs12 sm12 md12 lg12 xl12>
                                                <v-textarea
                                                    v-model="frmComment"
                                                    filled
                                                    auto-grow
                                                    label="Comments"
                                                    rows="4"
                                                    row-height="30"
                                                    shaped
                                                ></v-textarea>
                                            </v-flex>
                                                <template>                                               
                                                
                                                </template>


                                            <v-flex xs12 sm12 md12 lg12 xl12>
                                                <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">  </div>
                                            </v-flex>


                                        </v-layout>             
                                     </v-container> 


                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="save" 
                                    :disabled="dialogLoading"
                                    :loading="dialogLoading" 
                                    color="success" >Save </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-row>

                    <v-row>
                        <v-dialog v-model="dialogShowImages" persistent max-width="1000px"   >
                            <v-card>
                            <v-toolbar
                                color="indigo"
                                dark
                                >                              
                                <v-toolbar-title>ID: {{id_sign}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon @click="collectionsHide">close</v-icon>
                                </v-btn>
                                </v-toolbar>                                                
                                <v-card-text>

                                    <v-container  grid-list-sm class="pa-4 white" >              
                                        <v-layout row wrap>                
                                        
                                        <v-flex xs12 sm12 md12 lg12 xl12>
                                                <v-card
                                                elevation="24"
                                                max-width="85%"
                                                class="mx-auto"
                                            >
                                                <v-system-bar lights-out></v-system-bar>

                                            <v-carousel
                                                cycle
                                                height="100%"
                                                
                                                show-arrows-on-hover
                                                :cycle="cycle"
                                                v-model="model"
                                            >                                                                       

                                                <v-carousel-item
                                                v-for="(item,i) in itemsSOP"
                                                :key="i"
                                                >                                                                       
                                                    <v-row
                                                    class="fill-height"
                                                    align="center"
                                                    justify="center"
                                                    >                                                                        
                                                    <v-img
                                                        :src="item.img_path"
                                                        height="100%"
                                                        class="grey darken-4"
                                                        ></v-img>
                                                    
                                                    </v-row>                                                                        
                                                </v-carousel-item> 
                                            </v-carousel>
                                            </v-card>

                                        </v-flex>
                                                <template>                                              
                                                
                                                </template>
                                        </v-layout>             
                                    </v-container> 


                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>                                                            
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-row>

                


                </template>

                 

            </v-toolbar>
        </template>
               
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.ID">
                            <td>
                                <div >  
                                    <div >                                  
                                        <v-icon small class="mr-2" @click=" collectionsShow(item)">
                                            collections
                                        </v-icon>                                       
                                        <template >
                                            <v-icon small class="mr-2" @click="verStatusItem(item)">
                                                edit
                                            </v-icon>
                                        </template>
                                    </div>
                                </div>                                                                                               
                            </td>                  

                            <td class="text-xs-right">{{item.id_sign}} </td>                           
                            <td class="text-xs-right">{{item.contactType}} </td>
                            <td class="text-xs-right">{{item.contacName}} </td>  
                            <td class="text-xs-right">
                                <v-icon small class="mr-2" color="blue"  @click="downloadPowerPoint(item)"> 
                                     cloud_download
                                </v-icon>    
                            </td>   
                            
                            <!--<td class="text-xs-right">                                                        
                                <div v-if="item.condition">
                                    <span class="blue--text">Active</span>                                    
                                </div>
                                <div v-else>
                                <span class="red--text">Inactive</span>
                                </div>                                
                            </td>     -->                   
                            <!--<td class="text-xs-right">{{moment(item.create_dt).format('MM/DD/YYYY HH:mm')}} </td> -->                           

                        </tr>
                    </tbody>
                </template>
                     
                
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
    </v-data-table>
        </v-flex>

    </v-layout>
</template>

<script>    
    import axios from 'axios'; 
    import moment from 'moment'; 
   
    export default{
        components: {
                     
        },       
        data (){
            return {
                  moment:moment, 
                  id_sign: 0,               
                  aprovalList:[], 
                  verStatus: 0,                 
                  dialog: false,
                  dialogLoading: false,
                    headers: [
                        { text: 'Actions', value: 'action', sortable: false },  
                        { text: 'ID', value: 'id_sign', sortable: false },                    
                        { text: 'Contact type', value: 'contactType', sortable: false },
                        { text: 'UserName', value: 'contacName', sortable: false },                        
                        { text: 'Download', value: 'ppt_download', sortable: false }                      
                    ],
                    //moment: moment, // Set to whatever
                    //privileges: false,
                    
                    dialogShowImages:false,
                    model: 0,
                    cycle: false,
                    itemsSOP: [                       
                        ],
                    
                    frmStatus: 'Aproval',
                    frmComment: '',
                    statusSignItems: ['Aproval','Cancel','Reject'],
                    search: '',
                    desserts: [],
                    editedIndex: -1,
                  
                    id: '', 
                    part_number: '', 
                    part_number_alt: '', 
                    create_dt: '', 
                                      
                   
                    valida:0,
                    validaMensaje:[],

                    adModal: 0,
                    adAccion: 0, 
                    adName: '',
                    adId: '',

                    area: '',
                    description: ''

                                
            }   
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Area' : 'Edit Area'
            },
                          
        },

        watch: {
            dialog (val) {
            val || this.close()
            } ,
             dialogLoading (val)  {
                if (!val) return
            }          
        },

        created () {
            //console.log('Current User:' + this.$store.state.user.userName);
            this.initialize();
            this.listDocumentToSign();
            //this.havePriviges();     
        },

         methods: { 
           //   havePriviges() {
            //    this.$store.state.user.rol === "yms_customs" ? this.privileges =false : this.privileges =true
            //} ,   

             exitApp(){
                this.$store.dispatch("exit");
            },              
            listDocumentToSign(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_d_document_sign/List/' + this.$store.state.user.userName;                
                axios.get(url,configuration).then(function(response){                  
                    me.aprovalList = response.data;
                    console.log(me.aprovalList);                    
                }).catch(function(error){
                    console.log(error);
                });

            },
            
            initialize () {                            
            },
            downloadPowerPoint(item){
                console.log('Path= ',item.ppt_download);
                axios({
                    method: 'get',
                    url: item.ppt_download,
                    responseType: 'arraybuffer'
                })
                .then(response => {                    
                    this.forceFileDownload(response)                    
                })
                .catch(() => console.log('error occured')) 
                  
            },
            collectionsShow(item){
                this.dialogShowImages = true;                
                this.itemsSOP = item.imagesPath;
                this.model = 0;               
            },
            collectionsHide(){
                this.dialogShowImages = false;
            },
            
            editItem (item) {
                                               
                this.id= item.id_area;  
                this.area= item.area; 
                this.description= item.description; 
                this.condition= item.condition;
                      
                this.editedIndex=1;
                this.dialog = true
            },

            verStatusItem(item){
                this.verStatus = 1;
                this.id_sign = item.id_sign
            },
            hideStatus(){
                this.verStatus = 0;
                this.frmComment = '';
            },

            activeDesactiveItem (accion, item) {
                this.adModal= 1;
                this.adName = item.area;
                this.adId = item.id_area;

                if (accion == 1){
                   this.adAccion = 1;
                } else if (accion == 2){
                    this.adAccion = 2;
                } else{
                   this.adModal= 0;
                }                
            },

            activateDesactivateClose(){
                this.adModal = 0;
            },

            activate(){
                let me=this;
                   let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/dell_sop_s_area/Activate/' + this.adId,{},configuration).then(function(response){
                        me.adModal =0;
                        me.adAccion = 0;
                        me.adName = "";
                        me.adId = "";                       
                        me.listArea();                        
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);
            },
            deactivate(){
                let me=this;
                   let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/dell_sop_s_area/Desactivate/' + this.adId,{},configuration).then(function(response){
                        me.adModal =0;
                        me.adAccion = 0;
                        me.adName = "";
                        me.adId = "";                       
                        me.listArea();                        
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);
            },

            close () {
                this.dialog = false;
                this.dialogLoading = false;
                this.clean();
            },            
            clean() {               

                this.id_sign = 0;
                this.frmComment = '';
                this.frmStatus= 'Aproval';
                this.verStatus = 0;
                
                this.id= ""; 
                this.area= "";
                this.description= "";
                this.condition= ""; 
                  

                this.editedIndex=-1;

                this.valida= 0;
                this.validaMensaje= [];

            },           
          
            save () {               
                if (this.validar() > 0)  {                                      
                     return;   
                }                 
                let me=this;    
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token,
                        "Content-Type": "multipart/form-data"
                        };
                    let configuration = {headers : header };
                    this.dialogLoading = true;  

                    let formData = new FormData();                   
                    formData.append("id_sign", me.id_sign);
                    formData.append("status", me.frmStatus);
                    formData.append("comments", me.frmComment);
                    

                   axios.post('api/dell_sop_d_document_sign/SignDocument',formData,configuration).then(function(response){                      
                        me.close();                                        
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }                       
                        me.listDocumentToSign(); 
                        
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoading  = false,                        
                    ); 
                //console.log('Saving status');                      
            },
           
            validar() {
                 this.valida=0;
                 this.validaMensaje=[];
                 
                    
                 if (this.frmStatus != 'Aproval' && this.frmComment == ''){
                     this.validaMensaje.push('You need to put a comment when the status is: Cancel or Reject');
                 }                   
                  
                 if (this.validaMensaje.length){
                    this.valida=1;                    
                }                                             
                 return this.valida;
            },
        },
    }
</script>